import { render, staticRenderFns } from "./RecentSermons.vue?vue&type=template&id=602ef246&"
import script from "./RecentSermons.vue?vue&type=script&lang=js&"
export * from "./RecentSermons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports